'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useContext } from 'react';

import cx from 'clsx';
import { PreviousPathnameContext } from 'contexts/PreviousPathnameContext';
import PropTypes from 'prop-types';

import Logo from 'components/globals/Logo';

import Hero from './Hero';

import styles from './Landing.module.scss';

const Landing = ({ blocks = [] }) => {
    const prevPath = useContext(PreviousPathnameContext);
    return (
        <>
            <div
                className={cx(styles.splash, {
                    [styles.showIntro]: !prevPath,
                })}
            >
                <Logo withMorningStar className={styles.logo} />
                <p className={styles.tagline}>
                    Always a good day
                    <br />
                    to dairy.
                </p>
            </div>
            <Hero showIntro={!prevPath} />
            {blocks}
        </>
    );
};

Landing.propTypes = {
    blocks: PropTypes.array,
    contentTypeId: PropTypes.string,
    description: PropTypes.string,
    metaDescription: PropTypes.string,
    template: PropTypes.shape({
        blocks: PropTypes.arrayOf(
            PropTypes.shape({
                contentTypeId: PropTypes.string,
                title: PropTypes.string,
            })
        ),
        contentTypeId: PropTypes.string,
    }),
    seoTitle: PropTypes.any,
};

export default Landing;
